<template>
	<v-container fluid>
		<v-card>
			<v-card-title class="d-flex align-center">
				<v-icon
					icon="$gavel"
					start
				/>
				<translate>Permissions</translate>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col>
						<v-text-field
							v-model:model-value="permissionFilter"
							class="flex-shrink-1 flex-grow-0"
							:label="$gettext('Search for permission')"
							single-line
							hide-details
							variant="outlined"
							append-inner-icon="$search"
						/>
					</v-col>
					<v-spacer />
				</v-row>
				<v-row no-gutters>
					<v-col>
						<model-backend-table
							endpoint="/api/v0/permissions"
							:headers="headers"
							:filter="{'name': permissionFilter}"
							:sort-by="[{key: sortBy, order: sortDesc}]"
							:items-per-page="25"
							:items-per-page-options="[25, 50, 100]"
						>
							<template #item.name="{ item }">
								<a :href="`/bo/management/permissions/view?id=${item.id}`">
									{{ item.name }}
								</a>
							</template>
						</model-backend-table>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: 'PermissionsOverview',

	data () {
		return {
			permissionFilter: '',
			sortBy: 'created_at',
			sortDesc: true,
		};
	},

	computed: {
		headers () {
			return [
				{
					title: this.$gettext('Permission name'), value: 'name', sortable: true
				},
			];
		}
	},
};
</script>
